import { useId } from 'react';
import type { SVGProps } from 'react';

export const ArenaEssenceWordmark = (props: SVGProps<SVGSVGElement>) => {
  const gradientId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="25"
      viewBox="0 0 108 25"
      fill="none"
      {...props}
    >
      <path
        d="M21.6997 1.23242L21.8999 2.2207L25.4995 19.9551L28.6245 2.25195L28.8042 1.23242H44.2759L44.646 1.68555L47.4106 5.06836L47.7661 5.50293L47.6714 6.05762L46.5825 12.3809L46.5073 12.8213L46.1675 13.1104L44.5737 14.4668L44.396 14.6191L44.1743 14.6943L42.8423 15.1504L42.9438 15.3965L45.2642 21.0439L48.5806 2.25195L48.7603 1.23242H74.4536L74.7925 1.9209L77.8306 8.09375L78.1099 8.66016L78.0845 8.70703L78.73 10.0039L80.0894 2.25293L80.2681 1.23242H87.8325L87.5767 2.67969L84.5981 19.5537L94.4312 1.86719L94.7837 1.23242H101.899L102.099 2.2207L106.158 22.2207L106.458 23.6992H98.5142L98.3501 22.6582L97.9556 20.1689H94.1255L93.9985 19.0781L93.8442 17.748L93.8188 17.7998L93.8159 17.7793L93.1138 19.165L93.1255 19.1709L92.5405 20.3213L91.1665 23.0244L90.8237 23.6992H77.7124L77.3735 23.0098L73.3569 14.8389L73.0649 14.2451L73.0825 14.2139L73.022 14.0869L72.9976 14.2285L71.5181 22.6787L71.3394 23.6992H38.0562L37.7495 22.915L35.3501 16.7871H33.8452L32.8179 22.6777L32.6392 23.6992H18.3149L18.1509 22.6582L17.7573 20.1689H12.7144V19.4512L12.4771 19.918L12.5347 19.9424L11.937 21.1162L10.9673 23.0244L10.6245 23.6992H2.09619L3.11475 21.8672L14.2319 1.86719L14.5845 1.23242H21.6997ZM55.1851 8.99707H64.9429L64.6851 10.4463L63.8911 14.917L63.7104 15.9346H54.3003L54.0894 15.2998L53.979 15.9346H53.9702L53.8618 16.5273H65.0405L66.4741 8.4043H55.2935L55.1851 8.99707ZM96.0747 13.3506H96.8296L96.6499 12.2148L96.0747 13.3506ZM15.8755 13.3506H16.6313L16.4517 12.2139L15.8755 13.3506ZM35.1294 9.64453H39.1792L39.2866 9.55176L39.4858 8.4043H35.3452L35.1294 9.64453Z"
        fill="#00F040"
        stroke={`url(#${gradientId})`}
        strokeWidth="2.46587"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="104.95"
          y1="12.4658"
          x2="4.19189"
          y2="12.4658"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#023910" />
          <stop offset="1" stopColor="#1E1E1E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
